<script>
  import EntryContent from "./EntryContent.svelte"

  export let entry
</script>

<div class="entry-inline">
<EntryContent
  {entry}
  useInlineGallery={false}
  showDate={false}
  showHeading={entry.display.showHeading}
/>
</div>

<style>
  .entry-inline:not(:first-child) {
    margin-block-start: var(--spacer-xxl);
  }
  .entry-inline:not(:last-child) {
    margin-block-end: var(--spacer-xxl);
  }
</style>
